export interface ProblemRisk {
  title: string
  body: string
}

export const problemRisks: ProblemRisk[] = [
  {
    title: 'They break',
    body: 'Petals that crumble the moment you touch them, or blooms too thick to ever press well in the first place.',
  },
  {
    title: 'They lose color',
    body: 'Roses that turn brown and purples that fade to gray, because the drying went too slowly.',
  },
  {
    title: 'They stain',
    body: 'Trapped moisture, the wrong paper, and brown spots or mold you only find when you open the press.',
  },
  {
    title: 'They warp',
    body: 'Uneven pressure, wrinkled petals, and arrangements that never sit flat enough to frame.',
  },
  {
    title: 'You waste time and supplies',
    body: 'Weeks of waiting, frames and paper already paid for, and a whole batch that ends up in the trash.',
  },
]

export const problemAnswers: string[] = [
  'Which flowers to press (and which to skip before you waste weeks)',
  'How to keep their original shape and color',
  'How to catch the most common mistakes in time',
  'How to turn them into real, finished decor pieces',
]
